import clsx from 'clsx';
import { useContext, useEffect } from 'react';
import { LFC } from '../../types';
import { ShellContext } from './Header';
import styles from './Shell.module.css';

interface ShellContentProps {
  className?: string;
  noBackground?: boolean;
  full?: boolean;
}

export const ShellContent: LFC<ShellContentProps> = ({
  children,
  noBackground,
  full,
  className,
}) => {
  const {
    mini: [mini, setMini],
    content: [content],
  } = useContext(ShellContext);
  useEffect(() => {
    if (full) {
      setMini(true);
    } else {
      setMini(false);
    }
  }, [full, setMini]);

  return (
    <main className={clsx(styles.main)}>
      {!mini && <div className={styles.afterHeaderContent}>{content}</div>}
      <div
        className={clsx(
          styles.contentWrapper,
          noBackground && styles.noBackground,
          full && styles.full,
          className
        )}
      >
        <div className={clsx(styles.content)}>{children}</div>
      </div>
    </main>
  );
};
